import css from '@emotion/css';
import styled from '@emotion/styled';
import { layers } from '__app/spacing';
import { SIDEBAR_GAP, SIDEBAR_WIDTH } from '../AutomationFolders/constants';
import { KizenTypography } from '__app/typography';
import { TABLE_ROW_HEIGHT } from '__components/Tables/Basic';

export const StyledPlaceholderRow = styled.tr`
  height: 40px;
`;

export const StyledPlaceholderCell = styled.td`
  background-color: var(--color-background-light);
  & > div {
    width: 100%;
    height: 100%;
    border: 1px dashed var(--color-border-medium);
  }
  &:not(:first-of-type) > div {
    border-left-width: 0;
  }
  &:not(:last-of-type) > div {
    border-right-width: 0;
  }
`;

export const StyledDragItem = styled.div<{ dragging: boolean }>`
  ${({ dragging }) =>
    dragging
      ? css`
          width: ${SIDEBAR_WIDTH + SIDEBAR_GAP}px;
          cursor: grabbing;
          pointer-events: none;
        `
      : css`
          width: ${SIDEBAR_GAP}px;
          cursor: grab;
        `}

  height: ${TABLE_ROW_HEIGHT}px;
  position: relative;
  z-index: ${layers.popoverInModal};
  display: flex;
  align-items: center;
`;

export const StyledEmptyDragItem = styled.div`
  width: ${SIDEBAR_GAP}px;
  height: ${TABLE_ROW_HEIGHT}px;
`;

export const StyledDragHandle = styled.div<{ dragging: boolean }>`
  width: ${SIDEBAR_GAP}px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background-white);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  ${({ dragging }) =>
    dragging
      ? css`
          box-shadow: 0px 4px 4px 0px
            color-mix(in srgb, var(--color-background-black) 25%, transparent);
        `
      : ''}
`;

export const StyledCounts = styled(KizenTypography)`
  flex-shrink: 0;
  margin-left: -4px;
`;

export const StyledDragContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 15px 0 19px;
  border-radius: 4px;
  background-color: var(--color-background-white);
  border: 1px solid var(--color-border-medium-light);
  box-shadow: 0px 4px 4px 0px
    color-mix(in srgb, var(--color-background-black) 25%, transparent);
  position: relative;
  width: ${SIDEBAR_WIDTH}px;
  &:before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    bottom: -1px;
    width: 15px;
    background-color: var(--color-background-white);
    border: 1px solid var(--color-border-medium-light);
    border-right: none;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    z-index: 1;
  }
`;

export const StyledDropZone = styled.div<{
  isActive: boolean;
  dragging: boolean;
  isSelf: boolean;
  isAllowed: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: ${({ isAllowed }) => (isAllowed ? 'grabbing' : 'no-drop')} !important;
  ${({ isActive, dragging, isSelf }) =>
    isSelf
      ? css`
          background-color: var(--color-background-light);
          border: 1px dashed var(--color-border-medium);
        `
      : isActive
        ? css`
            border: 1px dashed var(--color-button-secondary-default);
          `
        : css`
            pointer-events: ${dragging ? 'auto' : 'none'};
          `}
`;
